import { render, staticRenderFns } from "./ForeignInfoCollectionPage.vue?vue&type=template&id=ea3f35a2&scoped=true&"
import script from "./ForeignInfoCollectionPage.vue?vue&type=script&lang=js&"
export * from "./ForeignInfoCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./ForeignInfoCollectionPage.vue?vue&type=style&index=0&id=ea3f35a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3f35a2",
  null
  
)

export default component.exports